import React from 'react';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { FocusAreas } from './components/FocusAreas';
import { PhilosophySection } from './components/PhilosophySection';
import { BrandMoment } from './components/BrandMoment';
function Divider() {
  return <div className="w-full flex justify-center py-12 opacity-30" data-id="element-0">
      <div className="w-1/3 md:w-1/4 h-px bg-brand-gold" data-id="element-1" />
    </div>;
}
export function App() {
  return <div className="min-h-screen bg-brand-dark text-brand-offWhite selection:bg-brand-gold/30 selection:text-brand-offWhite font-sans" data-id="element-2">
      <main data-id="element-3">
        <HeroSection data-id="element-4" />

        <Divider data-id="element-5" />

        <AboutSection data-id="element-6" />

        <Divider data-id="element-7" />

        <FocusAreas data-id="element-8" />

        <Divider data-id="element-9" />

        <PhilosophySection data-id="element-10" />

        <Divider data-id="element-11" />

        <BrandMoment data-id="element-12" />
      </main>
    </div>;
}